import { useCreateAdminAxiosInstance } from "./useCreateAdminAxiosInstance.ts";

export function useCreateProductServiceAdminAxiosInstance() {
  return useCreateAdminAxiosInstance(
    import.meta.env.VITE_PRODUCT_SERVICE_BASE_URL,
  );
}
